{
  "about_thing": "Una cosa es cualquier cosa que quieras: algo que comprar, un lugar adonde ir, algo que aprender o probar.",
  "about_what": "TingThings es donde guardas las cosas que quieres conseguir, hacer o lograr, y las compartes con tus amigos y tu familia.",
  "add_item_to_list": "Agregar un artículo a {title}",
  "app_name": "TingThings",
  "cancel": "Cancelar",
  "close": "Cerrar",
  "coming_up": "Próximo",
  "error": "Error",
  "items_count": {
    "one": "{count} artículo",
    "other": "{count} artículos"
  },
  "loading": "Cargando…",
  "nav_home": "Inicio",
  "nav_me": "Perfil",
  "nav_my_things": "Mis cosas",
  "nav_their_things": "Sus cosas",
  "no_account": "¿Aún no tienes cuenta?",
  "primary_navigation": "Principal",
  "private": "Privada",
  "refresh": "Actualizar",
  "return_to_sign_in": "Volver al inicio de sesión",
  "shared": "Compartida",
  "sign_in": "Iniciar sesión",
  "sign_out": "Cerrar sesión",
  "sign_up": "Registrarse",
  "signed_in_as": "Sesión iniciada como {email}",
  "signing_out": "Cerrando sesión…",
  "tagline": "Brindemos por las cosas que quieres",
  "working": "Procesando…"
}
